import React, { FocusEventHandler } from "react";

 interface SelectProps {
  onChange: (value: string) => void;
   onBlur?: FocusEventHandler<HTMLSelectElement> | undefined;
   selectedValues: null | string[];
   required?: boolean;
   options: {
     [id: string]: string;
   };
   
   defaultValue?: string;
 }
    function Dropdown({ onChange, onBlur, options, required  }: SelectProps) {

    return (
      <select
        className="form-control col-sm-8 col-md-6"
        onChange={(e) => onChange && onChange(e.target.value)}
        onBlur={onBlur}
        required={required}
      >
       {Object.entries(options).map(([id, text]) => (
        <option  key={id} value={text}>
          {text}
        </option>
      ))}
      </select>
    );
  }
;

export default Dropdown;
